// extracted by mini-css-extract-plugin
export default {"menu":"SideMenu_menu__LECN0","hidden":"SideMenu_hidden__5QHzA"};